<template>
  <div id="home" class="container">
    <Header />
    <Banner />
    <Section1 />
    <Section2 />
    <Section3 />
    <Section4 />
    <Section5 />
    <Footer />
  </div>
</template>

<script>
import Banner from '@/components/home/Banner.vue'
import Header from '@/components/home/Header.vue'
import Section1 from '@/components/home/Section1.vue'
import Section2 from '@/components/home/Section2.vue'
import Section3 from '@/components/home/Section3.vue'
import Section4 from '@/components/home/Section4.vue'
import Section5 from '@/components/home/Section5.vue'
import Footer from '@/components/home/Footer.vue'

export default {
  name: 'Home',
  components: {
    Banner,
    Header,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Footer
  }
}
</script>

<style scoped lang="scss">
#home {
  min-width: 99.2rem;
  font-size: 1.8rem;

  @include breakpoint(min-width, $screen-hd) {
    font-size: 2.1rem;
  }
}
</style>
